
import {
    TooltipProvider,
    Tooltip,
    TooltipTrigger,
    TooltipContent,
} from "../../components/ui/tooltip";
import "../../components/ui/tooltip-styles.css";


const InfoTooltip = ({ content }) => (
    <TooltipProvider>
        <Tooltip>
            <TooltipTrigger asChild>
                <button
                    type="button"
                    className="mini-btn info-btn ml-2"
                    aria-label="Column information"
                >
                    <span className="info-dot" aria-hidden>
                        i
                    </span>
                </button>
            </TooltipTrigger>
            <TooltipContent side="top">
                {content}
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
)

export default InfoTooltip;